/* eslint-disable camelcase */
import React, { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Grid,
} from "@mui/material"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { api, showSuccess, showWarning } from "../../../api"

const ModalEtapa = ({ open, onClose, data, pro_id }) => {
  const queryClient = useQueryClient()
  const [form, setForm] = useState(
    data || {
      pro_id,
      eta_secuencia: 1,
      eta_nombre: "",
      eta_tipo: "MANUAL",
      eta_sla_horas: 0,
      eta_requiere_obs: false,
      eta_bloquea_cierre: false,
      eta_estado: "A",
    },
  )

  const { mutateAsync: saveEtapa, isPending } = useMutation({
    mutationFn: async () => await api.post("/CRM_Carpetas/saveConfigEtapa", form),
    onSuccess: (res) => {
      showSuccess(res.data?.data || "Guardado correctamente.")
      queryClient.invalidateQueries(["getConfigEtapas"])
      onClose()
    },
    onError: (err) => showWarning(err.response?.data?.message || "Error al guardar."),
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{data ? "Editar Etapa" : "Nueva Etapa"}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              type="number"
              fullWidth
              label="Secuencia"
              margin="dense"
              value={form.eta_secuencia}
              onChange={(e) => setForm({ ...form, eta_secuencia: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField
              fullWidth
              label="Nombre de la Etapa"
              margin="dense"
              value={form.eta_nombre}
              onChange={(e) => setForm({ ...form, eta_nombre: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Tipo de Acción"
              margin="dense"
              value={form.eta_tipo}
              onChange={(e) => setForm({ ...form, eta_tipo: e.target.value })}
            >
              <MenuItem value="MANUAL">MANUAL (Botón)</MenuItem>
              <MenuItem value="AUTOMATICO">AUTOMÁTICO (Trigger ERP)</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              fullWidth
              label="SLA Máximo (Horas)"
              margin="dense"
              value={form.eta_sla_horas}
              onChange={(e) => setForm({ ...form, eta_sla_horas: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(form.eta_requiere_obs)}
                  onChange={(e) => setForm({ ...form, eta_requiere_obs: e.target.checked })}
                />
              }
              label="Exigir Observación Obligatoria"
            />
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(form.eta_bloquea_cierre)}
                  onChange={(e) => setForm({ ...form, eta_bloquea_cierre: e.target.checked })}
                />
              }
              label="Es paso de Auditoría de Cierre (Valida saldos)"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPending}>
          Cancelar
        </Button>
        <Button onClick={() => saveEtapa()} variant="contained" disabled={isPending}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEtapa
